// Copyright (c) billwerk GmbH. All rights reserved.
'use strict';

var BillingSettingsController = function ($scope, BillingSettings, gettext, gettextCatalog) {
    $scope.billingSettings = BillingSettings.get();
    $scope.tooltips = Object.freeze({
        "NegativeBillingDelay": gettext("Using a negative delay will affect billing and contract change actions.") +
            '<a href="https://docu.billwerk.plus/help/transform_en/en/configuration-and-settings/billing/how-does-the-billing-delay-work-.html#:~:text=Where%20can%20I%20view%20and%20change%20my%20billwerk%20contract%20information" target="_blank">' + gettextCatalog.getString(gettext('Read more.')) + '</a>'
    });
    $scope.save = function () {
        $scope.billingSettings.$update({}, function () {
            $scope.notifySuccess();
        });
    };

    var txt = function (msg) {
        return gettextCatalog.getString(msg);
    };

    $scope.PrepaidCardActionsForContractCancellation = Object.freeze({
        'Nothing': txt(gettext('No Action')),
        'End': gettextCatalog.getString('End', null, "End on the Billing Settings page"),
        'SwitchToFallback': txt(gettext('Switch to Fallback'))
    });

};
BillingSettingsController.$inject = ['$scope', 'BillingSettings', 'gettext', 'gettextCatalog'];
